import {defineType, defineField} from 'sanity'
import {ComponentPreview} from './ComponentPreview'
import {FaRectangleAd} from 'react-icons/fa6'

export default defineType({
  name: 'button-link',
  type: 'object',
  title: 'Button Link',
  icon: FaRectangleAd,
  components: {
    preview: (props) => <ComponentPreview {...props} />,
  },
  fields: [
    defineField({
      name: 'link',
      type: 'link',
      title: 'Link',
    }),
    defineField({
      name: 'buttonType',
      type: 'buttonType',
      title: 'Button Type',
    }),
  ],
  preview: {
    select: {
      title: 'link.label',
      subtitle: 'buttonType',
    },
  },
})
